import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type GetUserSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserSettingsQuery = { __typename?: 'Query', userSettings?: { __typename?: 'UserSettings', userId: string, isSelfPreviewEnabled: boolean } | null };

export type UpdateUserSettingsMutationVariables = Types.Exact<{
  input: Types.UserSettingsUpdateInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettings', userId: string, isSelfPreviewEnabled: boolean } };


export const GetUserSettingsDocument = `
    query GetUserSettings {
  userSettings {
    userId
    isSelfPreviewEnabled
  }
}
    `;
export const UpdateUserSettingsDocument = `
    mutation UpdateUserSettings($input: UserSettingsUpdateInput!) {
  updateUserSettings(input: $input) {
    userId
    isSelfPreviewEnabled
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    GetUserSettings: build.query<GetUserSettingsQuery, GetUserSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetUserSettingsDocument, variables })
    }),
    UpdateUserSettings: build.mutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>({
      query: (variables) => ({ document: UpdateUserSettingsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetUserSettingsQuery, useLazyGetUserSettingsQuery, useUpdateUserSettingsMutation } = injectedRtkApi;

